/*
 * GestioneAcl Messages
 *
 * This contains all the text for the GestioneAcl container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.GestioneAcl';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Role management',
  },
});
